import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import Table from "../../components/common/table/Table";
import {getTableColumns, getTableData} from "../../models/discountModel";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {deleteCustomerDiscount, fetchCustomersWithDiscount} from "../../store/customer-discount-slice";
import {resetCreateStatus, resetUpdateStatus} from "../../store/customer-discount-slice";

const DiscountView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        error,
        pagination
    } = useSelector(state => state.discount);

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchCustomersWithDiscount({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    const deleteHandler = (id) => {
        dispatch(deleteCustomerDiscount({...userRole, id})); // Updated action
    };

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);


    const tableColumns = getTableColumns({ActionDropdown, deleteHandler, customUrl: true});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="Customer Discount"/>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    )
}

export default DiscountView;